import React from "react";
import "./style.css";
import SimpleGallery from "./SimpleGallery";
import { images_list, images_list_new } from "./image_data";
import { motion } from "framer-motion";
import { fadeInUp } from "../../../animations/fadeVariants";

const Servis = () => {
  return (
    <section id="dokumentasi" className="service">
      <motion.div {...fadeInUp}>
        <h1 className="title">Dokumentasi Kerja</h1>
        <SimpleGallery
          galleryID="nrps-work-documentation"
          images={images_list}
          items={images_list.length}
        />
        <div className="newest-project">
          <h1 className="title">Proyek Terbaru</h1>
          <p className="project-description">
            JASA PENAMBAHAN STREAM GAS CUSTODY METER DI SKG LEMBAK PT. PERTAMINA
            EP ZONA 4 FIELD PRABUMULIH
          </p>
          <SimpleGallery
            galleryID="nrps-work-documentation"
            images={images_list_new}
            items={images_list_new.length}
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Servis;
